import React from 'react'
import PlusBlack from '../../../assets/img/plus-black.png'
import PlusWhite from '../../../assets/img/plus-white.png'
import MinusBlack from '../../../assets/img/minus-black.png'

const SelectedMeal = props => {
  const { product, addProduct, removeProduct } = props

  const qtyOrdered = product.qty
  const qtyTotal = product.stock

  return (
    <div className="cookunity__selected_product_details">
      <div
        className="product_image"
        style={{ backgroundImage: `url(${product.mealImage})` }}
      />

      <div className="product_name">
        <p>{product.mealFullName}</p>

        <div className="buttons">
          <button
            className="button"
            disabled={qtyOrdered <= 0}
            onClick={() => {
              if (!(qtyOrdered <= 0)) {
                removeProduct(product)
              }
            }}>
            <img src={MinusBlack} alt="minus" />
          </button>
          <div className="count">{product.qty}</div>
          <button
            className="button"
            disabled={qtyOrdered >= qtyTotal || qtyTotal === 0}
            onClick={() => {
              if (!(qtyOrdered >= qtyTotal || qtyTotal === 0)) {
                addProduct(product)
              }
            }}>
            <img
              src={
                qtyOrdered >= qtyTotal || qtyTotal === 0 ? PlusWhite : PlusBlack
              }
              alt="plus"
            />
          </button>
        </div>
      </div>

      <div className="product_price">
        <span>{product.formattedPrice}</span>
      </div>
    </div>
  )
}

export default SelectedMeal



// WEBPACK FOOTER //
// ./src/components/SelectedMeals/components/SelectedMeal.jsx